module.exports = __webpack_public_path__ + "static/ex_collection_list-e98cd4a326ecf580ad95ba6a7cd12d5b.png";